import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjectsService } from '../projects/projects.service';

@Injectable({
  providedIn: 'root'
})
export class SelectProjectResolver {
  private projectsService = inject(ProjectsService);

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    const project = route.paramMap.get('project') ?? '';

    return this.projectsService.selectProject(project);
  }
}
